import { Network } from '../interfaces'
import { ChainId } from './chainScan'

const chainIdToNetwork: { [key in ChainId]: Network } = {
  [ChainId.BSC_MAINNET]: Network.BNB_CHAIN,
  [ChainId.BSC_TESTNET]: Network.BNB_CHAIN,
  [ChainId.MATIC_MAINNET]: Network.POLYGON,
  [ChainId.MATIC_TESTNET]: Network.POLYGON,
  [ChainId.ETH_MAINNET]: Network.ETHEREUM,
  [ChainId.ETH_GOERLI]: Network.ETHEREUM,
  [ChainId.ETH_SEPOLIA]: Network.ETHEREUM,
  [ChainId.ARBITRUM_MAINNET]: Network.ARBITRUM,
  [ChainId.ARBITRUM_TESTNET]: Network.ARBITRUM,
  [ChainId.BASE_MAINNET]: Network.BASE,
  [ChainId.BASE_TESTNET]: Network.BASE
}

export const getNetworkFromChainId = (chainId: ChainId): Network => {
  return chainIdToNetwork[chainId]
}
